module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/montley-fool-b0033c696c6224d2893025d9aa1639a9.png";